<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    ATESTO -
                    <b-badge variant="warning">{{ operacao }}</b-badge>
                    <app-btn-voltar class="float-right"></app-btn-voltar>
                    <btn-nao-atesto
                        :atesto="atesto"
                        class="float-right mr-2"
                        v-if="
                            atesto &&
                            atesto.codSituacao == 0 &&
                            $temAcessoView('CONT-ATESTOS-01')
                        "
                        @obterAtestosAtualizados="obterAtestosAtualizados()"
                        @atualizarErros="erros = $event"
                    ></btn-nao-atesto>
                    <btn-atesto
                        :atesto="atesto"
                        class="float-right mr-2"
                        v-if="
                            atesto &&
                            atesto.codSituacao == 0 &&
                            $temAcessoView('CONT-ATESTOS-01')
                        "
                        @obterAtestosAtualizados="obterAtestosAtualizados()"
                        @atualizarErros="erros = $event"
                    ></btn-atesto>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <atesto-dados :atesto="atesto" v-if="atesto"></atesto-dados>
                <atesto-documentacao
                    class="mt-4"
                    v-if="
                        atesto && atesto.contrato
                            ? atesto.contrato.tipoEspecial
                            : false
                    "
                    v-model="comprovacoes"
                    :atesto="atesto"
                ></atesto-documentacao>
                <atesto-processos
                    class="mt-4"
                    :processos="atesto.processos"
                    v-if="atesto"
                ></atesto-processos>
                <atesto-pesquisa
                    class="mt-4"
                    v-if="atesto"
                    v-model="avaliacoes"
                    :atesto="atesto"
                ></atesto-pesquisa>
            </b-card-body>
            <b-card-footer v-if="atesto && atesto.codSituacao == 0">
                <btn-atesto
                    :atesto="atesto"
                    class="float-left mr-2"
                    v-if="
                        atesto &&
                        atesto.codSituacao == 0 &&
                        $temAcessoView('CONT-ATESTOS-01')
                    "
                    @obterAtestosAtualizados="obterAtestosAtualizados()"
                    @atualizarErros="erros = $event"
                ></btn-atesto>
                <btn-nao-atesto
                    :atesto="atesto"
                    class="float-left mr-2"
                    v-if="
                        atesto &&
                        atesto.codSituacao == 0 &&
                        $temAcessoView('CONT-ATESTOS-01')
                    "
                    @obterAtestosAtualizados="obterAtestosAtualizados()"
                    @atualizarErros="erros = $event"
                ></btn-nao-atesto>
                <app-btn-voltar class="float-left"></app-btn-voltar>
                <div class="float-right">
                    <label class="required ml-3 pt-2"></label>
                    <label class="ml-2 pt-2">Preenchimento Obrigatório</label>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import AtestosServicos from './AtestosServicos'
import AtestoDados from './AtestoDados'
import AtestoDocumentacao from './AtestoDocumentacao'
import AtestoProcessos from './AtestoProcessos'
import AtestoPesquisa from './AtestoPesquisa'
import BtnNaoAtesto from './BtnNaoAtesto'
import BtnAtesto from './BtnAtesto'

export default {
    components: {
        AtestoDados,
        AtestoDocumentacao,
        AtestoProcessos,
        AtestoPesquisa,
        BtnNaoAtesto,
        BtnAtesto
    },

    props: {},

    data() {
        return {
            md: 3,
            lg: 2,
            xl: 1,
            atesto: null,
            erros: [],
            operacao: 'DETALHAR',
            comprovacoes: null,
            avaliacoes: null
        }
    },

    methods: {
        obterAtesto() {
            this.$store.dispatch('addRequest')
            AtestosServicos.obterAtestoPorId(this.$route.params.atestoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.atesto = response.data
                            this.comprovacoes = {
                                comprovacao01: this.atesto.comprovacao01,
                                comprovacao02: this.atesto.comprovacao02
                            }
                            this.avaliacoes = {
                                avaliacoes: this.atesto.avaliacoes,
                                problemas: null
                            }
                        } else {
                            this.erros = response.errors
                            // this.$toast.error(
                            // 	'Erro ao obter os tipos de penalidades',
                            // 	'ERROR',
                            // 	this.$toastConfig.error
                            // )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterAtestosAtualizados() {
            this.$emit('obterAtestosAtualizados')
            this.$router.push({ name: 'Atestos' })
        }

        // confirmarSalvar() {
        // 	let msg
        // 	if (this.tipoOperacao == 'i') {
        // 		msg = 'Confirma a inserção da penalidade?'
        // 	} else {
        // 		msg = 'Confirma a atualização da penalidade?'
        // 	}

        // 	this.$swal({
        // 		title: 'Penalidade do Contrato',
        // 		html: msg,
        // 		type: 'warning',
        // 		showCancelButton: true,
        // 		confirmButtonColor: '#3085d6',
        // 		cancelButtonColor: '#d33',
        // 		confirmButtonText: 'Sim',
        // 		cancelButtonText: 'Não'
        // 	}).then(result => {
        // 		if (result.value) {
        // 			this.salvar()
        // 		}
        // 	})
        // },

        // salvar() {
        // 	this.$store.dispatch('addRequest')
        // 	let penalidadeDto = {
        // 		contratoId: this.contrato.idContrato,
        // 		tipoPenalidadeId: this.tipoPenalidadeId,
        // 		dataPenalidade: this.$moment(this.dataPenalidade, 'DD/MM/YYYY'),
        // 		descricao: this.descricao,
        // 		valorMulta: this.valorMulta,
        // 		recursoId: this.recursoId
        // 	}

        // 	if (this.tipoOperacao == 'a') {
        // 		penalidadeDto.penalidadeId = this.penalidadeId
        // 	}

        // 	let promisse
        // 	if (this.tipoOperacao == 'i') {
        // 		promisse = PenalidadesServicos.inserir(penalidadeDto)
        // 	} else {
        // 		promisse = PenalidadesServicos.atualizar(penalidadeDto)
        // 	}

        // 	promisse.then(response => {
        // 		if (response) {
        // 			if (response.success) {
        // 				this.registroSalvoComSucesso()
        // 			} else {
        // 				this.erros = response.errors
        // 			}
        // 		}
        // 		this.$store.dispatch('removeRequest')
        // 	})
        // },

        // registroSalvoComSucesso() {
        // 	this.$toast.success(
        // 		'Operação realizada com sucesso!',
        // 		'OK',
        // 		this.$toastConfig.success
        // 	)
        // 	this.$emit('obterPenalidadesAtualizadas')
        // 	this.fecharModal()
        // }
    },

    created() {
        this.obterAtesto()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        comprovacoes() {
            this.atesto.comprovacao01 = this.comprovacoes.comprovacao01
            this.atesto.comprovacao02 = this.comprovacoes.comprovacao02
        },

        avaliacoes() {
            this.atesto.avaliacoes = this.avaliacoes.avaliacoes
            this.atesto.problemas = this.avaliacoes.problemas
        }
    },

    validations: {
        // tipoPenalidadeId: {
        // 	required
        // },
        // dataPenalidade: {
        // 	required
        // },
        // valorMulta: {
        // 	required
        // },
        // descricao: {
        // 	required
        // },
        // recursoId: {
        // 	required
        // }
    }
}
</script>
